import range from 'lodash/range';

/**
 * pagination 없이 모든 목록을 불러옵니다.
 * 목록을 한번 불러왔을 때 완전히 불러와지지 않았으면 나머지 목록을 더 불러옵니다.
 */
export default async function getAllList<T>({
  queryFn,
  limit = 100,
}: {
  limit?: number;
  queryFn: (offset: number, limit: number) => Promise<{ count: number; list: T[] }>;
}): Promise<T[]> {
  let result = [await queryFn(0, limit)];
  const { count } = result[0];

  if (count > limit) {
    result = result.concat(
      await Promise.all(
        range(1, Math.floor(result[0].count / limit) + 1)
          .map((i) => i * limit)
          .map((offset) => queryFn(offset, limit))
      )
    );
  }

  return result.flatMap((v) => v.list);
}
